import * as actionTypes from "../actionTypes";
import * as api from "../../api/index";

// Step 1: collect name + email, backend emails a verification code.
export const RequestDemoAccess = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  let res, statusCode;
  try {
    const { data, status } = await api.requestDemoAccess(formData);
    res = data;
    statusCode = status;
    if (status !== 200 && status !== 201) {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data?.message });
    }
  } catch (error) {
    res = error?.response?.data;
    statusCode = error?.response?.status;
    dispatch({ type: actionTypes.SET_ERRORS, payload: error?.response?.data });
  } finally {
    setLoading(false);
  }
  return { res, statusCode };
};

// Step 2: verify the code, backend emails the signed video links.
export const VerifyDemoCode = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  let res, statusCode;
  try {
    const { data, status } = await api.verifyDemoCode(formData);
    res = data;
    statusCode = status;
    if (status !== 200) {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data?.message });
    }
  } catch (error) {
    res = error?.response?.data;
    statusCode = error?.response?.status;
    dispatch({ type: actionTypes.SET_ERRORS, payload: error?.response?.data });
  } finally {
    setLoading(false);
  }
  return { res, statusCode };
};
